import type { Session } from "@supabase/supabase-js";
import { supabase } from "./supabase";

export async function getSession(): Promise<Session | null> {
  try {
    const { data, error } = await supabase.auth.getSession();
    if (error) return null;
    return data?.session ?? null;
  } catch {
    return null;
  }
}

export function onAuthChange(cb: (session: Session | null) => void): () => void {
  try {
    const { data } = supabase.auth.onAuthStateChange((_event, session) => cb(session));
    return () => data?.subscription?.unsubscribe();
  } catch {
    return () => {};
  }
}

export async function signOut(): Promise<void> {
  try {
    await supabase.auth.signOut();
  } catch {
    // ignore
  }
}
